import { getAccountByTenantId } from "../../utils/accountUtils";

export const submitFormData = async ({
  data,
  sharePointService,
  instance,
  accounts,
  reset
}) => {
  try {
    if (!data.pdfFile) {
      console.error("No PDF file provided");
      throw new Error("PDF file is required");
    }

    if (!data.generatedFileName) {
      console.error("No generated filename provided");
      throw new Error("Generated filename is required");
    }

    const uploadResult = await sharePointService.uploadFile(
      data.pdfFile,
      data.generatedFileName
    );
    
    const tenantId = process.env.REACT_APP_AUTH_TENENT_ID;
    const account = getAccountByTenantId(accounts, tenantId);

    const response = await instance.acquireTokenSilent({
      scopes: [process.env.REACT_APP_AUTH_SP_SCOPE],
      account: account,
    });

    const graphApiUrl = process.env.REACT_APP_GRAPH_API_URL;
    const siteId = process.env.REACT_APP_SP_SITE_ID;
    const listId = process.env.REACT_APP_ENVIRONMENTAL_DOCUMENT_DATABASE_ID;

    const itemData = {
      fields: {
        field_2: data.title,
        field_0: Number(data.docId),
        field_3: data.reportDate
          ? data.reportDate.toISOString().split(".")[0] + "Z"
          : null,
        Title: data.title1,
        field_9: data.category,
        field_4: data.streetNumber,
        field_5: data.addressname || "",
        field_7: data.berth || "",
        field_8: data.building || "",
        field_11: Array.isArray(data.portarea) ? data.portarea.join(", ") : "",
        field_10: data.division,
        field_12: data.pdfName.split(".").pop().toUpperCase(),
        field_13: data.generatedFileName,
        field_6: data.sitename1,
        field_14: data.sitename2 || "",
        field_15: data.sitename3 || "",
        field_16: uploadResult.downloadLink,
      },
    };

    const createItemResponse = await fetch(
      `${graphApiUrl}/sites/${siteId}/lists/${listId}/items`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(itemData),
      }
    );

    if (!createItemResponse.ok) {
      const errorData = await createItemResponse.json();
      console.error("SharePoint API Error:", errorData);
      throw new Error(
        `Failed to create list item: ${JSON.stringify(errorData)}`
      );
    }

    // Create new item in Document Tracking List
    const trackingListResponse = await fetch(
      `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_DOCUMENT_TRACKING_LIST_ID}/items`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          fields: {
            Title: data.pdfName,
            Report_x0020_Submittee: data.Report_x0020_Submittee,
            Archival_x0020_Status: "Archived - New Entry",
            DOCID: Number(data.docId),
            Archived_x0020_PDF_x0020_Name: data.generatedFileName
          }
        }),
      }
    );

    if (!trackingListResponse.ok) {
      const errorData = await trackingListResponse.json();
      console.error("Document Tracking List API Error:", errorData);
      throw new Error(
        `Failed to create tracking list item: ${JSON.stringify(errorData)}`
      );
    }

    // If the file came from the Unentered Documents drive, delete it
    if (data.unenteredDocumentId) {
      try {
        await sharePointService.deleteFile(data.unenteredDocumentId);
      } catch (deleteError) {
        console.error("Error deleting file from Unentered Documents drive:", deleteError);
        // Don't throw error here as the main submission was successful
        // Just log the error for debugging purposes
      }
    }
    
    const returnData = {
      success: true,
      downloadLink: uploadResult.downloadLink,
      docId: data.docId,
      Title1: data.title1
    };

    reset();
    const fileInput = document.getElementById("pdf-upload");
    if (fileInput) {
      fileInput.value = "";
    }

    return returnData;
  } catch (error) {
    console.error("Error in form submission:", error);
    throw error;
  }
}; 